import React from 'react';
import { connect } from 'react-redux';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanelUpdate from './rightPanelUpdate';
import CenterPanelView from './centerPanelView';
import RightPanelView from './rightPanelView';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

export default function CreateUpdateWaitingArea(props) {
  const openInsertHelp = () => {
    window.open(APP.EXTERNAL_LINKS.ViewMeetingRoom.HelpCreate, '_blank');
  };
  const openUpdateHelp = () => {
    window.open(APP.EXTERNAL_LINKS.ViewMeetingRoom.HelpEditProperties, '_blank');
  };

  let rightPanel = {};
  let centerPanel = {};
  let title = undefined;
  let subtitle = undefined;
  let trimmedGroup = {};
  let orgName = props.waitingArea ? props.waitingArea.organisationName : '';
  var updatingWaitingAreaName = (props.waitingArea ? props.waitingArea.name : '') + ' (' + orgName + ')';
  if (props.updateOrView == 'update') {
    rightPanel = (
      <RightPanelUpdate
        waitingArea={props.waitingArea}
        waitingAreaOperatingHoursForm={props.waitingAreaOperatingHoursForm}
      />
    );
    centerPanel = (
      <CenterPanelUpdate
        timezones={props.timezones}
        waitingAreaOperatingHoursForm={props.waitingAreaOperatingHoursForm}
        waitingArea={props.waitingArea}
      />
    );
    title = APP.LANGUAGE.WaitingAreaOperatingHours.TitleUpdate;
    subtitle = updatingWaitingAreaName;
  } else {
    rightPanel = (
      <RightPanelView
        waitingArea={props.waitingArea}
        waitingAreaOperatingHoursForm={props.waitingAreaOperatingHoursForm}
      />
    );
    centerPanel = (
      <CenterPanelView
        timezones={props.timezones}
        waitingAreaOperatingHoursForm={props.waitingAreaOperatingHoursForm}
        waitingArea={props.waitingArea}
      />
    );
    title = APP.LANGUAGE.WaitingAreaOperatingHours.TitleView;
    subtitle = updatingWaitingAreaName;
  }
  let showModal = false;
  if (props.updateOrView == 'update') {
    showModal = props.showUpdateWaitingAreaOperatingHoursModal;
  } else {
    showModal = props.showViewWaitingAreaOperatingHoursModal;
  }

  return (
    <Modal show={showModal} hideWhenClickAway={false} className={props.updateOrView + '-waiting-area-operating-hours'}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpVideoCallAccessHours}
        title={title}
        subtitle={subtitle}
      />
      <div className="content">
        <div className="main-ui-container waiting-area-update">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
